// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"692684ab","703":"641a66d9"}[chunkId] + ".chunk.js";
};